import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[accountHost]',
})
export class AccountDirective {
    constructor(public viewContainerRef: ViewContainerRef) { }
}